import { RulesContent } from 'schemas/Content.schema';

const AwarenessRulesContent: RulesContent[] = [
  {
    name: 'Filter',
    type: 'F',
    description: 'Filter rules exclude people who should not receive these communications. For example, they do not meet the criteria or have recently used the service.',
  },
  {
    name: 'Suppression',
    type: 'S',
    description: 'Suppression rules exclude people who may meet the criteria but should not be contacted. For example, they have opted out, or they are managed by another service.',
  },
  {
    name: 'Routing',
    type: 'R',
    description: 'Routing rules let you send different messages to different groups. For example, you can use a separate routing plan for a specific age group or accessibility needs.',
  },
];

export default AwarenessRulesContent;
